export default {
  SET_INFO_CEDENT(state, {payload}) {
    state.cedents.selected = payload;
    
  },
};
